export const getLocalStorage = (id) => localStorage.getItem(id);
export const setLocalStorage = (id, data) => localStorage.setItem(id, data);
